module.exports = __webpack_public_path__ + "static/codelingo-md-ed99e3de508dd031f448416f9faeb088.jpg";